import type { SessionKind } from './SessionKind';

export type StoredSession = {
  kind: SessionKind;
  accessToken: string;
  refreshToken: string;
};

const SESSION_KEY = 'stock.bo.session';

export const readSession = (): StoredSession | null => {
  try {
    const raw = window.localStorage.getItem(SESSION_KEY);

    return raw ? (JSON.parse(raw) as StoredSession) : null;
  } catch {
    return null;
  }
};

export const writeSession = (session: StoredSession): void => {
  try {
    window.localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  } catch {
    // A browser with site data blocked simply signs the user out on reload.
  }
};

export const clearSession = (): void => {
  try {
    window.localStorage.removeItem(SESSION_KEY);
  } catch {
    // Nothing to clear.
  }
};
